/**
 * Created by zhoay on 2025/8/12
 * Desc: 信息服务费缴费
 */
import React, { Component } from 'react'
import { List, Toast, Form, Stepper } from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { getSearchParams, isObjEmpty, getIntValue, getStrValue, } from '../../utils/common'
import { Icon, message, Button, Cascader, InputNumber } from 'antd'
import { connect } from 'react-redux'

class PreviewApply extends Component {

    componentWillMount() {
        document.title = "信息服务费";
    }

    constructor(props) {
        super(props)

        this.state = {
            appId: null,
            openId: null,
            schoolData: [],
            optionss: [],
            schoolName: null,
            gradeClazz: null,
            stuName: null,
            psPhone: null,
            detailedAddress: null,
            cascaderValue: [],
            clazzId: this.props.match.params.clazzId,
            schoolId: this.props.match.params.schoolId,
            appId: this.props.match.params.appId,
            openId: this.props.match.params.openId,
            ruleId: this.props.match.params.ruleId,
            changed: 1,
            money: 0,
            upMoney: 0,
            buyType: 2,
            rechargeList: [],
        }
    }

    componentDidMount() {
        Toast.loading('努力加载中...', 0)
        this.getSchoolList()

        this.searchParams = getSearchParams(this.props.location.search)

    }

    render() {
        const { schoolData, optionss, schoolName, gradeClazz, stuName, psPhone, detailedAddress, money, upMoney, buyType } = this.state;

        const onChange = (value) => {
            console.log('changed', value);
            this.setState({
                changed: value,
                money: value * upMoney
            })
        };

        return (
            <div className='preview-page-root'>
                <div className='head-preview-page'>
                    <div style={{ textAlign: 'center' }}>
                        {/*服务内容*/}
                                                          <span className='service-content-title'>服务内容</span>
                                                          <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: 222222222 }} /></span>

                                                          {/*服务说明*/}
                                                          <span className='service-content-title'>服务说明</span>
                                                          <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: 3333333333 }} /></span>
                    </div>
                </div>
                <div className="tail-preview-page">
                    <div className="album-container" ref={node => this.node = node} onChange={this.handelValueCom}>
                        <div id='info-service-body'>


                                  {/*信息费列表*/}
                                  <span className='service-content-title'>信息费（元/年）</span>
                                  <div style={{ marginTop: '6px' }}>{11111111111111}</div>
                                </div>
                        <div style={{ textAlign: 'center' }}>
                            <img src={require('imgs/Album_c.png')} width={104} height={52} style={{ margin: '45px', white: 'white', textAlign: 'center' }} onClick={this.onNextClick} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (value) => {

        fetchGet(API.GET_AREA_LIST, {
        }).then(response => {
            Toast.hide();
            const { optionss } = this.state;

            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

                this.setState({
                    optionss: propertyArray
                })
            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    getSchoolList = () => {
        let { rechargeList } = this.state
            rechargeList.length = 0

        fetchGet(API.INFO_SERVICE_SERVICE_LIST, {
            //stuId: this.state.stuId,
            schoolId: this.state.schoolId,
            gradeId: this.state.ruleId,
        }).then(response => {
                Toast.hide()
                if (response && response.data && response.data.rulesList &&
                  response.data.rulesList.length > 0) {
                  rechargeList = response.data.rulesList
                }
                this.setState({
                  rechargeList,
                  isLoading: false,
                  serviceDate: response.data.allAsOfDate,
                  balance: response.data.allMoney,
                  payment: response.data.payment,
                }, () => {
                  console.log(rechargeList)
                })
              }).catch(error => {
                Toast.hide()

                this.setState({
                  rechargeList,
                })
                if (typeof error === 'string') {
                  Toast.fail(error, 2)
                } else {
                  Toast.fail('请求异常', 2)
                }
              })
            }



    onNextClick = (amount) => {

        const { cascaderValue, optionss, schoolName, gradeClazz, stuName, psPhone, detailedAddress, appId, openId, changed, money, upMoney, clazzId, schoolId } = this.state

        let err = ''

        /*if (optionss.length<3) {
                        Toast.fail('请输入省市区')
            return
        }*/
        if (money <= 0) {
            Toast.show('请输入正确的充值金额！')
            return
        }
        if (isObjEmpty(schoolName)) {
            Toast.fail('请输入学校')
            return
        }
        if (isObjEmpty(gradeClazz)) {
            Toast.fail('请输入班级')
            return
        }
        if (isObjEmpty(stuName)) {
            Toast.fail('请输入学生姓名')
            return
        }
        if (isObjEmpty(psPhone)) {
            Toast.fail('请输入手机号')
            return
        }

        const params = {
            //optionss: cascaderValue,
            school_name: schoolName,
            gradeClazz: gradeClazz,
            person_name: stuName,
            person_phone: psPhone,
            number: changed,
            money: upMoney,
            sumMoney: money,
            clazz_id: clazzId,
            school_id: schoolId,
            detailedAddress: detailedAddress,
            type: 2,
            appId: appId,
            openId: openId,
        }

        fetchPost(API.ALBUM_CHARGE_ORDER, { params: JSON.stringify(params) },
            {})
            .then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                Toast.show('支付失败！' + err)
            })
    }

    onBridgeReady = (json) => {
        console.log('json:', json)
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', JSON.parse(json),
            function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    Toast.success('支付成功！')
                    this.props.history.push('/previewPage/1')
                } else {
                    Toast.fail('支付失败！')
                    this.props.history.push('/previewPage/2')
                }
            })
    }

    handelValueCom = (event) => {
        //获取用户名的值
        let schoolName = this.refs.schoolName.value;
        let gradeClazz = this.refs.gradeClazz.value;
        let stuName = this.refs.stuName.value;
        let psPhone = this.refs.psPhone.value;
        let detailedAddress;
        if (this.state.buyType == 1) {
            detailedAddress = this.refs.detailedAddress.value;
        }
        //获得内容的值
        this.setState({
            schoolName: schoolName,
            gradeClazz: gradeClazz,
            stuName: stuName,
            psPhone: psPhone,
            detailedAddress: detailedAddress,
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewApply)
